var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcFilter24Dp = function SvgIcFilter24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 4v7.171a3.001 3.001 0 010 5.658V20H7v-3.17a3.001 3.001 0 010-5.66V4h2zm8 0v3.171a3.001 3.001 0 010 5.658V20h-2v-7.17a3.001 3.001 0 010-5.66V4h2z"
  }))));
};

export default "/_next/static/ic_filter_24dp-36caa36e5ea576d768049f4896da4d7csvg";
export { SvgIcFilter24Dp as ReactComponent };